<template>
    <row align="stretch" wrap-reversed>
        <column class="xs:items-center" md="1/2" sm="full" xs="full">
            <object :data="require('@/assets/images/components/applications_chart_grafic.svg')"
                    v-if="innerWidth < 640"
                    style="width: 100%; max-height: 250px;"
                    type="image/svg+xml"
                    id="app_svg_small"
                    @load="initAnimations()"
            ></object>
            <object :data="require('@/assets/images/components/applications_chart_grafic.svg')"
                    v-else
                    style="width: 100%"
                    type="image/svg+xml"
                    id="app_svg"
                    @load="initAnimations()"
            ></object>
        </column>
        <column md="1/2" sm="full" xs="full">
            <row align="stretch">
                <column v-for="(application, index) in applications" :key="index" xs="full" sm="1/2" class="pb-12">
                    <row align="center" no-wrap>
                        <column align="center" class="mr-4" justify="end" shrink style="min-width: 75px;">
                            <div class="text-accent poppins-bold tracking-normal leading-higher text-7xl">
                                {{ parse(index) }}
                            </div>
                        </column>
                        <column>
                            <div class="text-white text-left tracking-normal leading-snug text-xl"
                                 v-html="application"></div>
                        </column>
                    </row>
                </column>
            </row>
        </column>
<!--        <column align="center" class="sm:pl-12" md="1/2" sm="full" xs="full">-->
<!--            <div class="w-full">-->
<!--                <grid :cols="mobile ? 1 : 2"-->
<!--                      :flow-col="!mobile"-->
<!--                      :rows="mobile ? applications.length : Math.ceil(applications.length / 2)"-->
<!--                >-->
<!--                    <grid-cell :key="index"-->
<!--                               class="pb-12"-->
<!--                               v-for="(application, index) in applications"-->
<!--                    >-->
<!--                        <row align="center" no-wrap>-->
<!--                            <column align="center" class="mr-4" justify="end" shrink style="min-width: 75px;">-->
<!--                                <div class="text-accent poppins-bold tracking-normal leading-higher text-7xl">-->
<!--                                    {{ parse(index) }}-->
<!--                                </div>-->
<!--                            </column>-->
<!--                            <column>-->
<!--                                <div class="text-white text-left tracking-normal leading-snug text-xl"-->
<!--                                     v-html="application"></div>-->
<!--                            </column>-->
<!--                        </row>-->
<!--                    </grid-cell>-->
<!--                </grid>-->
<!--            </div>-->
<!--        </column>-->
        <column class="xs:pb-10 sm:pb-16" cols="full">
            <row justify="end">
                <column class="sm:pl-12" md="1/2" xs="full">
                    <divider class="xs:mb-2 sm:mb-6" color="accent" width="56"></divider>
                    <div
                        class="text-white text-left xs:mb-2 sm:mb-10 mt-3 poppins-bold tracking-normal xs:text-3xl sm:text-5xl leading-higher">
                        Applications
                    </div>
                </column>
            </row>
        </column>
    </row>
</template>

<script>
    import anime from "animejs";

    export default {
        name: "Applications",
        props: {
            applications: {type: Array, required: true}
        },
        components: {
            // grid: () => import('@/components/display/Grid.vue'),
            // 'grid-cell': () => import('@/components/display/GridCell.vue'),
            divider: () => import('@/components/Divider.vue'),
            row: () => import('@/components/display/Row.vue'),
            column: () => import('@/components/display/Col.vue'),
        },
        computed: {
            mobile() {
                return outerWidth <= parseInt(this.$theme.screens.sm.min.replace('px', ''));
            }
        },
        data: () => ({
            innerWidth: 0
        }),
        methods: {
            parse(value) {
                return (value + 1 < 10 ? '0' : '') + (value + 1).toString();
            },
            setInnerWidth() {
                this.innerWidth = window.innerWidth;
            },
            getElement(item, id) {
                return item.contentDocument.querySelector(id);
            },
            setInitialPosition(target, x, y) {
                anime.set(target, {translateX: x, translateY: y});
            },
            initAnimations() {
                    let main = document.querySelector('#app_svg') || document.querySelector('#app_svg_small'),
                        balloon = this.getElement(main, '#Path_810');
                    this.setInitialPosition(balloon, 28.421, -145.391);
                    this.animateBalloon(balloon, -165.391, 2000);
            },
            animateBalloon(target, translateY, duration) {
                anime({
                    targets: target,
                    translateY: translateY,
                    duration: duration,
                    direction: 'alternate',
                    loop: true
                });
            }
        },
        mounted() {
            window.addEventListener('resize', this.setInnerWidth);
            this.setInnerWidth();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setInnerWidth);
        }
    }
</script>

<style scoped>

</style>